import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { DynInputProps } from "..";

export default function DynSelect({
    spec,
    field,
    getFieldState
}: DynInputProps) {
    
    const {onChange, value} = field.field

    const opcoes = spec.options ?? []

    return (
        <FormControl fullWidth {...field} error={getFieldState(spec.name).invalid} margin="normal" required={spec.required}>
            <InputLabel id={`dyn-select-${spec.name}`}>{spec.label}</InputLabel>
            <Select
                labelId={`dyn-select-${spec.name}`}
                value={value}
                label={spec.label}
                onChange={(e) => onChange(e.target.value)}
            >
                {opcoes.map((item, index) => (
                    <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
            </Select>
            {getFieldState(spec.name).error && (
                <FormHelperText>{getFieldState(spec.name).error?.message}</FormHelperText>
            )}
        </FormControl>
    )
}